import { render, staticRenderFns } from "./DocumentUploadArea.vue?vue&type=template&id=1da3592a&scoped=true&"
import script from "./DocumentUploadArea.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadArea.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadArea.vue?vue&type=style&index=0&id=1da3592a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3592a",
  null
  
)

export default component.exports